// API utility functions for communicating with Flask backend
import { apiFetch } from './http';

export const getAllFoods = async () => {
  return apiFetch('/get_all_foods');
};

// Food recommendation endpoints
export const fetchTotalItems = async () => {
  return apiFetch('/total_items');
};

export const getFoods = async (preferences, positions, exclusions) => {
  return apiFetch('/get_foods', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ preferences, positions, exclusions })
  });
};

export const getFoodForTaste = async (preferences, attribute, position, exclusions) => {
  return apiFetch('/get_food_for_taste', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ preferences, attribute, position, exclusions })
  });
};

export const getRadarChart = async (preferences, positions, exclusions) => {
  const data = await apiFetch('/radar_chart', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ preferences, positions, exclusions })
  });
  return JSON.parse(data);
};

// User authentication endpoints
export const registerUser = async (firstName, lastName, username, password) => {
  return apiFetch('/api/register', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ firstName, lastName, username, password })
  });
};

export const loginUser = async (username, password) => {
  return apiFetch('/api/login', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ username, password })
  });
};

// Search tracking endpoints
export const saveSearch = async (username, preferences, positions, exclusions, results) => {
  return apiFetch('/api/save_search', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ username, preferences, positions, exclusions, results })
  });
};

export const fetchRecentSearches = async (username) => {
  return apiFetch(`/api/recent_searches/${username}`);
};

export const fetchMostSearched = async (username) => {
  return apiFetch(`/api/most_searched/${username}`);
};

// Favorites endpoints
export const getFavorites = async (username) => {
  return apiFetch(`/api/favorites/${username}`);
};

export const addFavorite = async (username, food_item) => {
  return apiFetch('/api/favorites', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ username, food_item })
  });
};

export const removeFavorite = async (username, food_item) => {
  return apiFetch('/api/favorites', {
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ username, food_item })
  });
};

// ─── Hybrid recommendation ────────────────────────────────────────────────
export const recommendHybrid = async ({
  username = '',
  sliders = {},
  seedFoods = [],
  context = {},
  exclusions = {},
  topK = 10,
  excludeTried = false,
} = {}) => {
  return apiFetch('/recommend_hybrid', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      username,
      sliders,
      seed_foods: seedFoods,
      context,
      exclusions,
      top_k: topK,
      exclude_tried: excludeTried,
    }),
  });
};

// ─── Feedback ─────────────────────────────────────────────────────────────
export const submitFeedback = async ({
  username = '',
  firstName = '',
  foodName,
  cravingFit,
  discoveryFit,
  triedBefore = false,
  saved = false,
  clicked = false,
  rejected = false,
  comment = '',
} = {}) => {
  return apiFetch('/submit_feedback', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      username,
      first_name: firstName,
      food_name: foodName,
      craving_fit: cravingFit,
      discovery_fit: discoveryFit,
      tried_before: triedBefore,
      saved,
      clicked,
      rejected,
      comment,
    }),
  });
};

// ─── User profile ─────────────────────────────────────────────────────────
export const getUserProfile = async (username) => {
  return apiFetch(`/api/user_profile/${username}`);
};

// ─── Seed food vector (show user the implied taste profile) ───────────────
export const getSeedFoodVector = async (seedFoods) => {
  return apiFetch('/seed_foods', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ seed_foods: seedFoods }),
  });
};
